(function () {
  // Mobile + desktop drawer toggles (hamburger icons)
  var toggles = document.querySelectorAll('[data-gf-menu-toggle]');
  var drawer = document.querySelector('[data-gf-drawer]');
  var overlay = document.querySelector('[data-gf-drawer-overlay]');
  var closeBtn = document.querySelector('[data-gf-drawer-close]');

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  toggles.forEach(function (t) {
    t.addEventListener('click', function () {
      if (drawer && drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  });
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // Help dropdown
  var helpEl = document.querySelector('[data-gf-help]');
  if (helpEl) {
    var trigger = helpEl.querySelector('[data-gf-help-trigger]');
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = helpEl.hasAttribute('open');
      if (isOpen) {
        helpEl.removeAttribute('open');
      } else {
        helpEl.setAttribute('open', '');
      }
    });
    document.addEventListener('click', function (e) {
      if (!helpEl.contains(e.target)) helpEl.removeAttribute('open');
    });
  }

  // Deliver-to / country selector — centered modal popup (Inspire Uplift style).
  // Uses Shopify's native localization form so the chosen country carries
  // through to checkout automatically.
  var deliverTrigger = document.querySelector('[data-gf-deliver-trigger]');
  var deliverOverlay = document.querySelector('[data-gf-deliver-overlay]');
  var deliverModal = document.querySelector('[data-gf-deliver-modal]');
  if (deliverTrigger && deliverOverlay && deliverModal) {
    var deliverClose = deliverModal.querySelector('[data-gf-deliver-close]');
    var deliverSelect = deliverModal.querySelector('[data-gf-deliver-select]');
    var deliverInput = deliverModal.querySelector('[data-gf-deliver-input]');
    var deliverForm = deliverModal.querySelector('form');

    function openDeliverModal() {
      deliverOverlay.removeAttribute('hidden');
      deliverModal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }
    function closeDeliverModal() {
      deliverOverlay.setAttribute('hidden', '');
      deliverModal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    deliverTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      openDeliverModal();
    });
    if (deliverClose) {
      deliverClose.addEventListener('click', function (e) {
        e.stopPropagation();
        closeDeliverModal();
      });
    }
    deliverOverlay.addEventListener('click', closeDeliverModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !deliverModal.hasAttribute('hidden')) closeDeliverModal();
    });
    if (deliverSelect) {
      deliverSelect.addEventListener('change', function () {
        if (deliverInput) deliverInput.value = deliverSelect.value;
        if (!deliverForm) return;
        deliverSelect.disabled = true;
        if (typeof deliverForm.requestSubmit === 'function') {
          deliverForm.requestSubmit();
        } else {
          deliverForm.submit();
        }
      });
    }
  }

  // Cart drawer toggles (mobile + desktop icons)
  var cartToggles = document.querySelectorAll('[data-gf-cart-toggle]');
  if (cartToggles.length) {
    cartToggles.forEach(function (el) {
      el.addEventListener('click', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) return; // no drawer on page (cart_type isn't "drawer"), fall back to normal link nav
        e.preventDefault();
        if (typeof drawer.open === 'function') {
          drawer.open(el);
        } else {
          drawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }
      });
    });
  }

  // Keep our own cart-count badge in sync (we intentionally don't use Dawn's
  // #cart-icon-bubble section swap, since it replaces our icon markup with its own).
  function gfUpdateCartCount(count) {
    document.querySelectorAll('[data-gf-cart-toggle]').forEach(function (el) {
      var badge = el.querySelector('.gf-cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'gf-cart-count';
          el.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      fetch('/cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          gfUpdateCartCount(cart.item_count);
        })
        .catch(function () {});
    });
  }

  // Predictive search
  var searchForm = document.querySelector('[data-gf-search-form]');
  if (searchForm) {
    var searchInput = searchForm.querySelector('[data-gf-search-input]');
    var resultsBox = searchForm.querySelector('[data-gf-search-results]');
    var debounceTimer;
    var controller;

    function closeResults() {
      resultsBox.classList.remove('is-visible');
    }

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function renderResults(products, query) {
      if (!products.length) {
        resultsBox.innerHTML =
          '<div class="gf-search-results__empty">No products found for &ldquo;' + escapeHtml(query) + '&rdquo;</div>';
        resultsBox.classList.add('is-visible');
        return;
      }
      var html = products
        .map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          return (
            '<a class="gf-search-result" href="' + p.url + '">' +
            '<img src="' + img + '" alt="" loading="lazy">' +
            '<span class="gf-search-result__info">' +
            '<span class="gf-search-result__title">' + escapeHtml(p.title) + '</span>' +
            '<span class="gf-search-result__price">' + p.price + '</span>' +
            '</span></a>'
          );
        })
        .join('');
      html +=
        '<a class="gf-search-results__viewall" href="/search?q=' +
        encodeURIComponent(query) +
        '">View all results</a>';
      resultsBox.innerHTML = html;
      resultsBox.classList.add('is-visible');
    }

    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < 2) {
        closeResults();
        return;
      }
      debounceTimer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        fetch(
          '/search/suggest.json?q=' +
            encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
          { signal: controller.signal }
        )
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            var products =
              (data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(products, q);
          })
          .catch(function (err) {
            if (err.name !== 'AbortError') closeResults();
          });
      }, 250);
    });

    searchInput.addEventListener('focus', function () {
      if (searchInput.value.trim().length >= 2 && resultsBox.innerHTML) resultsBox.classList.add('is-visible');
    });

    document.addEventListener('click', function (e) {
      if (!searchForm.contains(e.target)) closeResults();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeResults();
    });
  }

  // Social proof rotating popup
  var popup = document.querySelector('[data-gf-social-proof]');
  if (popup) {
    var items = [];
    try {
      items = JSON.parse(popup.getAttribute('data-items') || '[]');
    } catch (err) {
      items = [];
    }
    var closeProofBtn = popup.querySelector('[data-gf-social-proof-close]');
    var imgEl = popup.querySelector('[data-gf-sp-img]');
    var textEl = popup.querySelector('[data-gf-sp-text]');
    var dismissed = false;
    var idx = -1;

    function pickNext() {
      if (!items.length) return null;
      var next;
      do {
        next = Math.floor(Math.random() * items.length);
      } while (items.length > 1 && next === idx);
      idx = next;
      return items[idx];
    }

    function showNext() {
      if (dismissed || !items.length) return;
      var item = pickNext();
      if (!item) return;
      imgEl.src = item.image;
      imgEl.alt = item.product;
      textEl.innerHTML =
        'Someone from <b>' + item.city + '</b> just bought<br><a href="' + item.url + '">' + item.product + '</a>';
      popup.classList.add('is-visible');
      setTimeout(function () {
        popup.classList.remove('is-visible');
      }, 5500);
    }

    if (closeProofBtn) {
      closeProofBtn.addEventListener('click', function () {
        dismissed = true;
        popup.classList.remove('is-visible');
      });
    }

    setTimeout(showNext, 4000);
    setInterval(showNext, 12000);
  }
})();
